const SPECIALTIES = [
  "General Physician",
  "Cardiology",
  "Dermatology",
  "Orthopedics",
  "Pediatrics",
  "Neurology",
  "Ophthalmology",
  "ENT (Ear, Nose, Throat)",
  "Gynaecology & Obstetrics",
  "Gastroenterology",
  "Pulmonology",
  "Psychiatry",
  "Psychiatric Consultant",
  "Urology",
  "Endocrinology",
  "Nephrology",
  "Oncology",
  "Rheumatology",
  "Anesthesiology",
  "Radiology",
  "Pathology",
  "Emergency Medicine",
  "General Surgery",
  "Internal Medicine",
  "Family Medicine",
  "Sports Medicine",
  "Plastic Surgery",
  "Neurosurgery",
  "Cardiac Surgery",
  "Vascular Surgery",
  "Pediatric Surgery",
  "Geriatrics",
  "Allergology & Immunology",
  "Infectious Diseases",
  "Hematology",
  "Hepatology",
  "Neonatology",
  "Nuclear Medicine",
  "Pain Medicine",
  "Physical Medicine & Rehabilitation",
  "Preventive Medicine",
  "Sleep Medicine",
  "Thoracic Surgery",
  "Transplant Surgery",
  "Trauma Surgery",
  "Vascular Medicine",
  "Dental & Maxillofacial Surgery",
  "Dietetics & Nutrition",
  "Physiotherapy",
  "Psychology",
  "Speech Therapy",
  "Occupational Therapy",
  "Chiropractic",
  "Acupuncture",
  "Homeopathy",
  "Ayurveda",
  "Naturopathy",
  "Dental Surgery",
  "Orthodontics",
  "Periodontics",
  "Endodontics",
  "Prosthodontics",
];

export default SPECIALTIES;
